export default __webpack_public_path__ + "static/media/login-bg-52.2b653ea7.jpg";